<template>
    <div class="error-msg-wrap">
        <div class="form-wrapper slide-up">
            <div class="form-close">
                <button type="button" class="form-close-x" title="Close" @click="$emit('close')">&times;</button>
            </div>
            <h4 style="margin:0 0 2px">{{ entry.userName }}</h4>
            <div style="font-size:12px;color:#a8a4a0;margin-bottom:14px">{{ dateLabel }} &middot; {{ entry.done }}/{{ entry.total }} items completed</div>

            <div v-if="parsed.weeklyItems.length" class="chk-weekly">
                <div class="chk-weekly-head"><svg-icon icon="calendar" />Weekly Items</div>
                <div v-for="(item, i) in parsed.weeklyItems" :key="'w'+i">
                    <div v-if="item.type == 'textblock'" class="playbook-process checklist-text-block">
                        <div v-html="item.text"></div>
                    </div>
                    <div v-else class="chk-item ro" :class="{ on: item.checked }">
                        <div>
                            <b>{{ item.label }}<span v-if="item.description">:</span></b>&nbsp;<span>{{ item.description }}</span>
                            <span v-if="item.carriedFromLabel" class="chk-missed">Missed {{ item.carriedFromLabel }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="parsed.oneOffItems.length" class="chk-oneoff">
                <div class="chk-oneoff-head"><svg-icon icon="plus" />One-Off Items</div>
                <div v-for="(item, i) in parsed.oneOffItems" :key="'o'+i" class="chk-item ro" :class="{ on: item.checked }">
                    <div style="margin:0">
                        <b>{{ item.label }}</b>
                        <span v-if="item.carriedFromLabel" class="chk-missed">Missed {{ item.carriedFromLabel }}</span>
                    </div>
                </div>
            </div>

            <div v-for="(item, i) in parsed.items" :key="'i'+i">
                <div v-if="item.type == 'textblock'" class="playbook-process checklist-text-block" style="margin: 20px 0">
                    <div style="margin:0" v-html="item.text"></div>
                </div>
                <div v-else class="chk-item ro" :class="{ on: item.checked }">
                    <div style="margin:0">
                        <b>{{ item.label }}<span v-if="item.description">:</span></b>&nbsp;<span>{{ item.description }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import SvgIcon from '@/components/SvgIcon.vue';

export default defineComponent({
    name: 'ChecklistLogDetail',
    props: [ 'entry' ],
    components: {
        SvgIcon
    },
    computed: {
        parsed(): any {
            try {
                const p = JSON.parse(this.entry.raw.ChecklistJSON);
                return { items: p.items || [], weeklyItems: p.weeklyItems || [], oneOffItems: p.oneOffItems || [] };
            } catch(e) {
                return { items: [], weeklyItems: [], oneOffItems: [] };
            }
        },
        dateLabel(): string {
            const parts = this.entry.dateString.split('-').map((n: string) => parseInt(n));
            const d = new Date(parts[0], parts[1] - 1, parts[2]);
            return d.toLocaleDateString('en-US', { weekday: 'long', month: 'short', day: 'numeric', year: 'numeric' });
        }
    }
});
</script>
